import React, { useEffect, useMemo, useState } from "react";
import "./VerticalTabs.css";

const VerticalTabs = ({
  tabs = [],
  TabComp,
  TabContent,
  compProps,
}) => {
  console.log("VerticalTabs",compProps?.currentCampDetails?.startDate)
  const safeTabs = Array.isArray(tabs) ? tabs : [];

  const [activeIndex, setActiveIndex] = useState(0);
  const currentTabData = safeTabs[activeIndex] || {};
  // When tabs change due to polling:
  useEffect(() => {
    // keep index in range
    if (activeIndex >= safeTabs.length) {
      setActiveIndex(0);
    }
    // If you want to auto-switch to a specific tab on data refresh,
    // do it here based on some predicate.
  }, [safeTabs.length, activeIndex]);

  // Prefer a data key; fall back to index only if nothing else exists.
  const getKey = (tab, index) =>
    tab?.id ?? tab?._id ?? tab?.key ?? tab?.slug ?? tab?.updatedAt ?? `idx-${index}`;

  return (
    <div className="vertical-tabs-container">
      {/* Left Tabs */}
      <div className={`vertical-tabs`}>
        {safeTabs.map((tab, index) => (
          <div
            key={getKey(tab, index)}
            className={`tab-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => setActiveIndex(index)}
          >
            {/* If TabComp holds internal state and must remount on data change,
                also give TabComp its own key below */}
            <TabComp key={getKey(tab, index)} content={tab} />
          </div>
        ))}
      </div>

      {/* Right Content */}
      <div className="vertical-tab-content">
        <TabContent
          {...compProps}
          content={{ ...currentTabData, ...compProps }}
        />
      </div>
    </div>
  );
};

export default VerticalTabs;
